import { ProductSelectionPartsModel } from "@tCooneyBrothers/ApiModels";
import CustomApplicationState from "@tCooneyBrothers/Store/CustomApplicationState";
import ProductSelectionPartsState from "@tCooneyBrothers/Store/Data/ProductSelectionParts/ProductSelectionPartsState";

export function getProductSelectionPartsCollection(state: ProductSelectionPartsState) {
    return state?.value;
}

export function getProductSelectionPartsCollectionV2(
    state: CustomApplicationState,
): ProductSelectionPartsModel[] | undefined {
    return state.cbData?.productSelectionParts?.value || undefined;
}
